import { render, staticRenderFns } from "./showTwoContent.vue?vue&type=template&id=56bfa48b"
import script from "./showTwoContent.vue?vue&type=script&lang=js"
export * from "./showTwoContent.vue?vue&type=script&lang=js"
import style0 from "./showTwoContent.vue?vue&type=style&index=0&id=56bfa48b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports